import { MultiSelectInputV2 } from '@frontend/components/basic-forms';
import { TransactionStateName } from '@frontend/transaction/types';

import { useTransactionStatesField } from './transaction-states-field.controller';

export interface TransactionStatesFieldProps {
    onChange: (value: string[] | null) => void;
    value: string[] | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    isClearable?: boolean;
}

export const TransactionStatesField = (props: TransactionStatesFieldProps) => {
    const viewProps = useTransactionStatesField();

    return (
        <MultiSelectInputV2<TransactionStateName>
            {...props}
            isLoading={viewProps.isLoading}
            options={viewProps.options}
            value={props.value ? (props.value as TransactionStateName[]) : []}
            onSelect={(value) => {
                if (value === null) return;
                props.onChange(value.map((v) => v.value));
            }}
            isClearable={props.isClearable ?? true}
        />
    );
};
